module.exports = __webpack_public_path__ + "img/onboarding_icon_6.a16468cf.svg";